import { Outlet } from "@tanstack/react-router"
import { Pagination } from "modules/shared/components/Pagination"
import { usePagination } from "modules/shared/hooks/usePagination"
import { useSortBy } from "modules/shared/hooks/useSortBy"
import { useActionRequestsQuery } from "modules/support/hooks/useActionRequestsQuery"
import { SearchSchema } from "routes/_base/_auth/support/list/route"
import { SupportSortFields } from "schema"
import { z } from "zod"
import { ActionRequestsTable } from "./ActionRequestsTable"

const ITEMS_PER_PAGE = 30

type Props = {
  fullPath: string
  search: z.infer<typeof SearchSchema>
}

export function ActionRequests({ fullPath, search }: Props) {
  const { page, totalPages, setPage, setCount, count } = usePagination({
    search,
    fullPath,
    total: ITEMS_PER_PAGE,
  })

  const { onSort, sortBy, fields } = useSortBy<typeof SupportSortFields>({
    search,
    fullPath,
    fields: ["createdAt"],
  })

  const { data, isPending } = useActionRequestsQuery({
    query: {
      page,
      total: ITEMS_PER_PAGE,
      sortBy,
      filterBy: search.filterBy,
      query: search.query,
    },
    onSuccess: (data) => {
      setCount(data.pageInfo.count)
    },
  })

  return (
    <>
      <ActionRequestsTable
        actionRequests={data}
        isPending={isPending}
        fields={fields}
        onSort={onSort}
        search={search}
      />
      <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} count={count} />
      <Outlet />
    </>
  )
}
